// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"34a22575","695":"b09738d6","974":"694ea54f"}[chunkId] + ".chunk.css";
};